import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import Card from "../controls/Card";
import { Link } from "react-router-dom";

export default function UserRegisterCompleted() {
    return (
        <div className="flex flex-col min-h-full justify-center px-6 py-12 lg:px-8 bg-slate-100">
            <div className="mx-auto w-full max-w-sm p-6 flex flex-col min-h-full justify-center">

                <Card isBorder={true}>

                    <div className="mt-5 sm:mx-auto text-center sm:w-full sm:max-w-sm ">
                        <div className="flex flex-col items-center justify-center space-y-3">
                            <div className="flex justify-center mb-4 text-green-500 text-4xl">
                                <FaCheckCircle />
                            </div>
                            <h2 className="text-2xl font-bold text-green-600 mb-2">Account Created Successfully!</h2>
                            <p className="text-gray-700">
                                Your account has been created. Please wait for verification. This process may take up to <strong>24 hours</strong>. We will contact you soon.
                            </p>
                            <Link to="/login">
                                <button className="text-sm flex justify-center items-end  hover:text-blue-800 text-blue-600 ">
                                    <span className='ms-1'>Back to login</span>
                                </button>
                            </Link>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}

